<template>
  <div class="modal" :class="{'is-active': opened}">
    <div class="modal-background"></div>
    <div class="modal-card wide-modal">
      <header class="modal-card-head">
        <p class="modal-card-title">Inbound shipment item</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div v-if="error" class="notification is-danger is-light">
          <button class="delete" @click="error=''"></button>
          {{error}}
        </div>
        
        <div v-if="poItem">
          <div class="field">
            <label class="label">Line</label>
            <div class="control">
              <input class="input is-static" type="text" v-model="poItem.line" readonly>
            </div>
          </div>
          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input class="input is-static" type="text" v-model="poItem.itemName" readonly>
            </div>
          </div>
          <div class="field">
            <label class="label">Description</label>
            <div class="control">
              <input class="input is-static" type="text" v-model="poItem.description" readonly>
            </div>
          </div>
          <div class="field">
            <label class="label">Quantity</label>
            <div class="control">
              <input class="input is-static" type="number" v-model="poItem.quantity" readonly>
            </div>
          </div>
          <div class="field">
            <label class="label">Container</label>
            <div class="control">
              <input class="input" type="text" v-model.number="shipmentContainer">
            </div>
          </div>
          <div class="field">
            <label class="label">Shipment quantity</label>
            <div class="control">
              <input class="input" :class="{'is-danger': !isShipmentQuantityValid}" type="number" min="0" :max="remaining" v-model.number="shipmentQuantity">
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" :class="{'is-loading': waiting}" :disabled="!isItemValid" @click="saveInboundItem">Save</a>
        <a class="button" @click="close">Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'inbound-item-modal',
  props: ['opened', 'pos', 'item', 'inbound'],
  data () {
    return {
      error: '',
      waiting: false,
      poId: '',
      poItem: null,
      po: null,
      shipmentContainer: '',
      shipmentQuantity: null,
      poRemaining: null,
      remaining: null,
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    isItemValid () {
      return this.poItem && this.shipmentContainer && this.shipmentQuantity && this.shipmentQuantity <= this.remaining
    },
    isShipmentQuantityValid () {
      return (this.shipmentQuantity == null) || (this.shipmentQuantity >= 0 && this.shipmentQuantity <= this.remaining)
    },
  },
  watch: {
    opened (val) {
      if (val) {
        this.poRemaining = null
        this.remaining = null
        this.shipmentQuantity = null
        this.poId = this.item.poId
        this.po = JSON.parse(JSON.stringify(this.item.po))
        this.poItem = JSON.parse(JSON.stringify(this.item.poItem))
        this.shipmentContainer = this.item.containerInfo.split('(')[0]
        this.shipmentQuantity = this.item.quantityExpected
        if (this.poItem.className == 'OVERFLOW') {
          this.poRemaining = this.poItem.quantity
          this.remaining = this.poItem.quantity
        } else if (this.poId) {
          this.waiting = true
          this.$http.get(this.server + '/myapp/get-purchase-order-items-with-inbounds/' + this.poId).then(resp => {
            var remaining = 0
            resp.body.forEach(i => {
              if (i.line == this.poItem.line) {
                remaining = i.quantity
                if (remaining <= 0) {
                  remaining = 0
                } else {
                  for (var ib of i.inbounds) {
                    if (ib.inbound.id != this.inbound.id) {
                      remaining -= ib.inboundItem.quantityExpected
                    }
                  }
                }
              }
            })
            this.poRemaining = remaining
            this.computeRemaining()
            this.waiting = false
          }, err => {
            this.error = err.body
            this.waiting = false
          })
        }
      }
    },
    shipmentQuantity (val) {
      if (this.remaining != null && val != null && val > this.remaining) {
        this.shipmentQuantity = this.remaining
      }
      if (val != null && val < 0) {
        this.shipmentQuantity = 0
      }
    },
  },
  methods: {
    close () {
      this.$emit('closeInboundItemModal')
    },
    saveInboundItem () {
      if (!this.isItemValid) {
        return
      }
      var obj = {
        item: this.item,
        po: this.po,
        poItem: this.poItem,
        shipmentContainer: this.shipmentContainer,
        shipmentQuantity: this.shipmentQuantity,
        shipmentItemClass: this.poItem.className,
      }
      this.$emit('closeInboundItemModal', obj)
    },
    computeRemaining () {
      var remaining = this.poRemaining
      for (var i=0;i<this.inbound.items.length;i++) {
        if (this.inbound.items[i].idx == this.item.idx) {
          continue
        }
        var ii = this.inbound.items[i]
        if (ii.poId != this.poId) {
          continue
        }
        if (ii.shipmentItemName == this.poItem.itemName.split(':')[1].trim() && ii.shipmentItemDescription.trim() == this.poItem.description.trim()) {
          remaining -= ii.quantityExpected
        }
      }
      if (remaining < 0) {
        remaining = 0
      }
      this.remaining = remaining
    },
  },
}
</script>

<style scoped>
.wide-modal {
  width: 800px!important;
}
</style>